import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "name", "extension", "canHideMetadata", "filesize", "hasStatus", "statusLabel", "statusVariant", "statusHasLight", "statusIsGhost", "action"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './FileLockup.styles';
import WordSvg from './images/docx.svg';
import ExcelSvg from './images/xlsx.svg';
import PowerpointSvg from './images/pptx.svg';
import ImageSvg from './images/image.svg';
import MediaSvg from './images/media.svg';
import PdfSvg from './images/pdf.svg';
import ZipSvg from './images/zip.svg';
import CsvSvg from './images/csv.svg';
import GenericSvg from './images/generic.svg';
import GsheetSvg from './images/gsheet.svg';
import TxtSvg from './images/txt.svg';
import Truncate from '../Truncate';
import FormatFileSize from '../FormatFileSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FileLockup = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      mode = _ref.mode,
      name = _ref.name,
      _ref$extension = _ref.extension,
      extension = _ref$extension === void 0 ? '' : _ref$extension,
      _ref$canHideMetadata = _ref.canHideMetadata,
      canHideMetadata = _ref$canHideMetadata === void 0 ? false : _ref$canHideMetadata,
      filesize = _ref.filesize,
      _ref$hasStatus = _ref.hasStatus,
      hasStatus = _ref$hasStatus === void 0 ? false : _ref$hasStatus,
      _ref$statusLabel = _ref.statusLabel,
      statusLabel = _ref$statusLabel === void 0 ? '' : _ref$statusLabel,
      _ref$statusVariant = _ref.statusVariant,
      statusVariant = _ref$statusVariant === void 0 ? 'default' : _ref$statusVariant,
      _ref$statusHasLight = _ref.statusHasLight,
      statusHasLight = _ref$statusHasLight === void 0 ? false : _ref$statusHasLight,
      _ref$statusIsGhost = _ref.statusIsGhost,
      statusIsGhost = _ref$statusIsGhost === void 0 ? false : _ref$statusIsGhost,
      action = _ref.action,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-file-lockup"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var nameLength = name.length;
  var imageSrc;

  switch (extension.toLowerCase()) {
    case 'xlr':
    case 'xls':
    case 'xlsb':
    case 'xlsm':
    case 'xlsx':
    case 'xlt':
    case 'xltm':
    case 'xltx':
    case 'xlw':
    case 'ods':
      imageSrc = ExcelSvg;
      break;

    case 'gsheet':
      imageSrc = GsheetSvg;
      break;

    case 'txt':
    case 'rtf':
    case 'xml':
    case 'xps':
    case 'xhtml':
    case 'html':
    case 'htm':
    case 'log':
      imageSrc = TxtSvg;
      break;

    case 'pdf':
      imageSrc = PdfSvg;
      break;

    case 'jpg':
    case 'jpeg':
    case 'jpe':
    case 'jp2':
    case 'j2k':
    case 'jpf':
    case 'jpx':
    case 'jpm':
    case 'mj2':
    case 'jif':
    case 'jfif':
    case 'jfi':
    case 'png':
    case 'gif':
    case 'webp':
    case 'tiff':
    case 'tif':
    case 'psd':
    case 'raw':
    case 'arw':
    case 'cr2':
    case 'nrw':
    case 'k25':
    case 'bmp':
    case 'dib':
    case 'heif':
    case 'heic':
    case 'svg':
    case 'svgz':
    case 'epi':
    case 'ai':
      imageSrc = ImageSvg;
      break;

    case 'webm':
    case 'mpg':
    case 'mp2':
    case 'mpeg':
    case 'mp3':
    case 'mpv':
    case 'ogg':
    case 'mp4':
    case 'm4p':
    case 'm4v':
    case 'avi':
    case 'wmv':
    case 'mov':
    case 'qt':
    case 'flv':
    case 'swf':
      imageSrc = MediaSvg;
      break;

    case '7z':
    case 'a00':
    case 'a01':
    case 'a02':
    case 'ace':
    case 'agg':
    case 'ain':
    case 'alz':
    case 'apex':
    case 'apz':
    case 'ar':
    case 'arc':
    case 'archiver':
    case 'gzip':
    case 'ipk':
    case 'package':
    case 'pak':
    case 'pkg':
    case 'rar':
    case 'rz':
    case 'tar.bz2':
    case 'tar.gz':
    case 'tar.gz2':
    case 'tar.lz':
    case 'tar.lzma':
    case 'tar.xz':
    case 'tar.z':
    case 'taz':
    case 'tbz':
    case 'tbz2':
    case 'tg':
    case 'tgz':
    case 'uha':
    case 'uzip':
    case 'war':
    case 'warc':
    case 'xapk':
    case 'xar':
    case 'xef':
    case 'xez':
    case 'xip':
    case 'zip':
    case 'zipx':
    case 'zix':
    case 'zl':
    case 'zoo':
    case 'zpi':
    case 'zsplit':
    case 'zst':
    case 'zz':
      imageSrc = ZipSvg;
      break;

    case 'csv':
      imageSrc = CsvSvg;
      break;

    case 'doc':
    case 'docm':
    case 'docx':
    case 'dot':
    case 'dotm':
    case 'dotx':
    case 'odt':
    case 'wps':
      imageSrc = WordSvg;
      break;

    case 'odp':
    case 'pot':
    case 'potm':
    case 'potx':
    case 'pps':
    case 'ppsm':
    case 'ppsx':
    case 'ppt':
    case 'pptm':
    case 'pptx':
      imageSrc = PowerpointSvg;
      break;

    default:
      imageSrc = GenericSvg;
      break;
  }

  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(Styled.FileLockup, _objectSpread(_objectSpread({
      ref: ref,
      className: className
    }, rest), {}, {
      children: [_jsx(Styled.FileLockupIcon, {
        children: _jsx("img", {
          src: imageSrc,
          alt: extension
        })
      }), _jsxs(Styled.FileLockupContent, {
        children: [name && _jsxs(Styled.FileLockupName, {
          children: [_jsx(Styled.FileLockupNameFull, {
            children: nameLength > 50 ? _jsx(Truncate, {
              start: 18,
              end: 18,
              children: name
            }) : name
          }), _jsx(Styled.FileLockupNameShort, {
            children: _jsx(Truncate, {
              children: name
            })
          })]
        }), _jsxs(Styled.FileLockupMetadataContainer, {
          children: [(filesize || extension) && !canHideMetadata && _jsxs(Styled.FileLockupMetadata, {
            children: [(filesize || !isNaN(filesize)) && _jsx(Styled.FileLockupMetadataItem, {
              children: _jsx(Styled.FileLockupMetadataItemContent, {
                children: typeof filesize === 'number' ? _jsx(FormatFileSize, {
                  children: filesize
                }) : filesize
              })
            }), extension && _jsx(Styled.FileLockupMetadataItem, {
              children: _jsx(Styled.FileLockupMetadataItemContent, {
                children: extension
              })
            })]
          }), hasStatus && _jsx(Styled.FileLockupMetadataStatusContainer, {
            children: _jsx(Styled.FileLockupMetadataStatus, {
              status: statusVariant,
              isGhost: statusIsGhost,
              hasStatusLight: statusHasLight,
              children: statusLabel
            })
          })]
        })]
      }), action && _jsx(Styled.FileLockupAction, {
        children: action
      })]
    }))
  });
});
FileLockup.displayName = 'FileLockup';
export default FileLockup;